import React from 'react';

export const DeleteIcon = ({ color = '#475467' }: { color?: string }) => {
    return (
        <svg
            width='20'
            height='23'
            viewBox='0 0 20 23'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 5.5H3M3 5.5H19M3 5.5V19.5C3 20.0304 3.21071 20.5391 3.58579 20.9142C3.96086 21.2893 4.46957 21.5 5 21.5H15C15.5304 21.5 16.0391 21.2893 16.4142 20.9142C16.7893 20.5391 17 20.0304 17 19.5V5.5H3ZM6 5.5V3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5H12C12.5304 1.5 13.0391 1.71071 13.4142 2.08579C13.7893 2.46086 14 2.96957 14 3.5V5.5M8 10.5V16.5M12 10.5V16.5'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const CircleDeleteIcon = ({ color = '#E04F16' }: { color?: string }) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.99984 14.1667L9.99984 11.1667L12.9998 14.1667L14.1665 13L11.1665 10L14.1665 7.00002L12.9998 5.83335L9.99984 8.83335L6.99984 5.83335L5.83317 7.00002L8.83317 10L5.83317 13L6.99984 14.1667ZM9.99984 18.3334C8.84706 18.3334 7.76373 18.1146 6.74984 17.6771C5.73595 17.2396 4.854 16.6459 4.104 15.8959C3.354 15.1459 2.76025 14.2639 2.32275 13.25C1.88525 12.2361 1.6665 11.1528 1.6665 10C1.6665 8.84724 1.88525 7.76391 2.32275 6.75002C2.76025 5.73613 3.354 4.85419 4.104 4.10419C4.854 3.35419 5.73595 2.76044 6.74984 2.32294C7.76373 1.88544 8.84706 1.66669 9.99984 1.66669C11.1526 1.66669 12.2359 1.88544 13.2498 2.32294C14.2637 2.76044 15.1457 3.35419 15.8957 4.10419C16.6457 4.85419 17.2394 5.73613 17.6769 6.75002C18.1144 7.76391 18.3332 8.84724 18.3332 10C18.3332 11.1528 18.1144 12.2361 17.6769 13.25C17.2394 14.2639 16.6457 15.1459 15.8957 15.8959C15.1457 16.6459 14.2637 17.2396 13.2498 17.6771C12.2359 18.1146 11.1526 18.3334 9.99984 18.3334ZM9.99984 16.6667C11.8609 16.6667 13.4373 16.0209 14.729 14.7292C16.0207 13.4375 16.6665 11.8611 16.6665 10C16.6665 8.13891 16.0207 6.56252 14.729 5.27085C13.4373 3.97919 11.8609 3.33335 9.99984 3.33335C8.13873 3.33335 6.56234 3.97919 5.27067 5.27085C3.979 6.56252 3.33317 8.13891 3.33317 10C3.33317 11.8611 3.979 13.4375 5.27067 14.7292C6.56234 16.0209 8.13873 16.6667 9.99984 16.6667Z'
                fill={color}
            />
        </svg>
    );
};
